import Header from './../../../Headers/HeaderForAreLoggedIn/index.vue'
import ProgressHUD from './../../../ProgressHUD/index.vue'
import GoogleMap from './../../../GoogleMap/VueGoogleMap.vue'
import VueCropper from 'vue-cropper'
import { Api, Toast, Helper } from './../../../../services'

export default {
  name: 'ProjectExistingDuplicate',
  props: [],
  components: {
    Header,
    ProgressHUD,
    VueCropper,
    GoogleMap,
  },
  data() {
    return {
      project: {
        name: '',
        greenTokenWallet: '',
        type: '',
        streetAddress: '',
        streetAddress2: '',
        city: '',
        stateProvince: '',
        zipCode: '',
        country: '',
        dateInstallation: '',
        nameplateCapacity: '',
        documentations: [],
        affilietCode: '',
        latitude: null,
        longitude: null,
        images: null,
        capacitySize: ''
      },
      validationMessage: '',
      types: {
        0: 'Solar',
        1: 'Concentration Solar',
        2: 'Wind',
        3: 'Biogas',
        4: 'Wood Gasification',
        5: 'Gasification of Organics',
        6: 'Waste Gasification',
        7: 'Hydroelectric',
        8: 'Undumotor',
      },
      option: {
        img: null,
        size: 1,
        outputType: 'png',
        res: '',
        w: 1200,
        h: 400,
      },
      capacitySize: 0
    }
  },
  methods: {
    setHeightImage() {
      var pic_box = $('.picture-box')
      if (pic_box && pic_box[0]) {
        var h = document.getElementById('content').clientHeight
        pic_box[0].style.height =
          (h > screen.availHeight ? h - 80 : screen.availHeight - 80) + 'px'
      }
    },

    // whenever the document is resized, re-set the 'fullHeight' variable
    handleResize(event) {
      this.setHeightImage()
    },

    async saveProject() {
      try {
        const isValid = await this.$validator.validateAll('firstForm')
        if (!isValid) {
          Toast.validationFieldsError({ toast: this.$toast })
          return
        }

        this.$refs.progress.show()

        this.project.latitude = this.$refs.googleMap.marker.position.lat()
        this.project.longitude = this.$refs.googleMap.marker.position.lng()
        this.project.type = this.$refs.selectType.value
        this.project.country = this.$refs.selectCountry.value
        this.project.capacitySize = (this.capacitySize === 0) ? "MW" : "KW"

        var formData = new FormData()

        for (var key in this.project) {
          formData.append(key, this.project[key])
        }

        for (var i = 0; i < this.project.documentations.length; i++) {
          formData.append(
            'documentationfiles' + i,
            this.project.documentations[i]
          )
        }

        let image = await this.cropIt()
        formData.append('files0', image)
        for (
          var index = 1;
          !(!(index < this.project.images.length) || !(index < 5)); // Upload 5 images or less
          index++
        ) {
          formData.append('files' + index, this.project.images[index])
        }

        // let image = await this.cropIt()
        // formData.append('files0', image)

        var response = await Api.addProject(formData)

        this.$router.push('/dashboard/')
      } catch (error) {
        this.validationMessage = 'Something went wrong.'

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'Something went wrong.',
        })
      } finally {
        this.$refs.progress.hide()
      }
    },

    async getProject() {
      try {
        var response = await Api.getSystemsDetailById(this.$route.params.id)
        var resultDate = response.data.results[0]

        this.project.name = resultDate.project.name
        this.project.greenTokenWallet = resultDate.project.greenTokenWallet
        this.project.streetAddress = resultDate.project.streetAddress
        this.project.streetAddress2 = resultDate.project.streetAddress2
        this.project.city = resultDate.project.city
        this.project.stateProvince = resultDate.project.stateProvince
        this.project.zipCode = resultDate.project.zipCode
        this.project.country = resultDate.project.country
        this.project.dateInstallation = resultDate.project.dateInstallation
        this.project.nameplateCapacity = resultDate.project.nameplateCapacity
        this.project.capacitySize = resultDate.project.capacitySize
        this.capacitySize = (resultDate.project.capacitySize === "MW") ? 0 : 1
        this.project.affilietCode = resultDate.project.affilietCode
        this.project.type = resultDate.project.type
        this.project.latitude = resultDate.project.latitude
        this.project.longitude = resultDate.project.longitude

        this.$refs.selectCountry.value = this.project.country
        this.$refs.selectType.value = this.project.type

        //this.option.img = resultDate.project.images[0]

        await new Promise(resolve => this.$nextTick(resolve))

        this.$refs.googleMap.setPosition(
          this.project.latitude,
          this.project.longitude
        )
      } catch (error) {
        this.validationMessage = 'Something went wrong.'

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'Something went wrong.',
        })
      } finally {
        this.$refs.progress.hide()
      }
    },

    onFileDocumentationsChange(event) {
      var files = event.target.files || event.dataTransfer.files
      this.project.documentations = files
    },

    onFileChange(event) {

      var files = event.target.files || event.dataTransfer.files
      this.project.images = files

      if (this.project.images.length > 5) {
        this.$toast.error({
          title: 'Error',
          message: 'You can upload up to five images',
          color: '#BD362F',
        })
      }

      if (files && files[0]) {
        var reader = new FileReader()
        let _self = this
        reader.onload = e => {
          var img = new Image()
          img.onload = function() {
            _self.option.w = img.width / (img.height / 400)
          }
          img.src = reader.result
          _self.option.img = e.target.result
        }
        reader.readAsDataURL(files[0])
      }
    },

    cropIt() {
      return new Promise((resolve, reject) => {
        if (this.$refs.cropper.imgs == '') {
          reject({ message: 'Please upload the image' })
          return
        }

        this.$refs.cropper.startCrop()
        this.$refs.cropper.getCropData(image => {
          console.log(image)
          fetch(image)
            .then(res => res.blob())
            .then(blob => {
              const file = new File([blob], 'image.png')
              resolve(file)
            })
            .catch(error => {
              reject(error)
            })
        })
      })
    },
  },
  async created() {
    this.countries = require('./../../../../data/country.js')

    await this.getProject()

    this.$nextTick(function() {
      Materialize.updateTextFields()
      $('select').material_select()
    })
  },
  async mounted() {
    this.setHeightImage()
    window.addEventListener('resize', this.handleResize)
  },
}



// WEBPACK FOOTER //
// ./src/components/Project/SystemsDetail/ProjectExistingDuplicate/ProjectExistingDuplicate.component.js